(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('Sexo', Sexo);

    Sexo.$inject = ['$resource', 'DateUtils'];

    function Sexo ($resource, DateUtils) {
        var resourceUrl =  'api/sexos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
